//i18n.js

import Vue from 'vue'
import VueI18n from 'vue-i18n'
import messages from './langs'
import { getCookie } from './cookie'

Vue.use(VueI18n)
const i18n = new VueI18n({
  locale: localStorage.lang || 'cn',
  // locale: getCookie('PLAY_LANG','cn'),
  messages
})

export default i18n



// WEBPACK FOOTER //
// ./src/i18n/i18n.js